export default __webpack_public_path__ + "static/toolpoollight-cf32a70bdf7e0e8e4d8a0261975f56f7.png";